<template>
    <div class="content">

        <div class="searchContent" v-show="(orgAuthCodeList.length <= 0 && activeName == 'first') || activeName == 'second'">
            <el-button class="btn desktop" @click="setAuthCode"  v-show="orgAuthCodeList.length <= 0 && activeName == 'first' ">生成</el-button>
            <el-button class="btn report" @click="setPadCode" v-show="activeName == 'second'" >生成</el-button>
        </div>


        <div class="list_box">
            <el-tabs v-model="activeName">
                <el-tab-pane name="first" label="桌面打印程序授权">
                    <!--<div class="searchContent">
                        &lt;!&ndash;<el-button style="background: #009688;margin-left:15px;" @click="setAuthCode" v-show="orgAuthCodeList.length <= 0">生成</el-button>&ndash;&gt;
                        <el-button style="background: #009688;margin-left:15px;" @click="setAuthCode" >生成</el-button>
                    </div>-->
                    <div class="list_content">
                        <el-table :data="orgAuthCodeList" :height="winHeight" :cell-style="setRowStyle"  :header-cell-style="getHeaderStyle"  >
                            <el-table-column prop="orgId" label="站点ID"></el-table-column>
                            <el-table-column prop="orgName" label="站点名称"></el-table-column>
                            <el-table-column prop="authCode" label="授权码"></el-table-column>
                            <el-table-column fixed="right" label="操作">
                                <template slot-scope="scope">
                                    <el-button
                                            @click="copyAutoCode(scope.row)"
                                            type="primary"
                                            size="small"
                                            class="copy_btn"
                                    >复制</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                    </div>
                </el-tab-pane>
                <el-tab-pane name="second" label="报告展示Pad授权">
                    <!--<div class="searchContent">
                        <el-button style="background: #009688;" @click="setPadCode" >生成</el-button>
                    </div>-->
                    <div class="list_content">
                        <el-table :data="padCodeList" :height="winHeightPad" :cell-style="setRowStyle"  :header-cell-style="getHeaderStyle" >
                            <el-table-column prop="orgId" label="站点ID"></el-table-column>
                            <el-table-column prop="orgName" label="站点名称"></el-table-column>
                            <el-table-column prop="authCode" label="Pad授权码"></el-table-column>
                            <el-table-column prop="bindImei" label="绑定pad的Imei"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button @click="delPadCode(scope.row)" type="danger" size="small" >删除</el-button>
                                    <el-button @click="unboundPadCode(scope.row)" type="warning" size="small" v-if="scope.row.bindImei" >解绑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

    </div>
</template>

<script>
  import net from "../../assets/js/public";
  export default {
    name: "deviceAuthList",
    data(){
      return {
        signInfo:'',
        orgId:'',
        orgName:'',
        orgAuthCodeList:[],
        padCodeList:[],
        winHeight:'200',
        winHeightPad:'200',
        activeName:'first'
      }
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.signInfo = signInfo
      this.orgId = signInfo.orgId
      this.orgName = signInfo.orgName

      this.addOrgAuthCode()
      this.getPadCode()
    },
    methods:{
      getHeaderStyle() {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      setRowStyle(row, column, rowIndex, columnIndex) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },

      // 获取授权码
      addOrgAuthCode(){
        net.request("admin/dossier/deviceAuth/getOrgAuthCode","post", {orgId: this.orgId,token:this.signInfo.token}).then(res => {
          if (res.retcode === 1) {
            this.orgAuthCodeList = res.data
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
            this.winHeightPad = windiwHight - 350
          } else {
            net.message(this, res.retmsg, "warning")
          }
        })
      },
      // 生成授权码
      setAuthCode(){
        const params= {
          orgId: this.orgId,
          orgName: this.orgName,
          token: this.signInfo.token
        }
        net.request('admin/dossier/deviceAuth/addOrgAuthCode','post',params).then(res => {
          if(res.retcode === 1){
            net.message(this, res.retmsg, "success")
            this.addOrgAuthCode()
          }else {
            net.message(this, res.retmsg, "warning")
          }
        })
      },
      // 复制授权码
      copyAutoCode(row){
        let authCode = row.authCode
        let oInput = document.createElement('input');
        oInput.value = authCode;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },

      // 获取Pad授权码
      getPadCode(){
        const params = {
          orgId: this.orgId,
          token: this.signInfo.token
        }
        net.request('admin/dossier/deviceAuth/getOrgPadAuthCode','post',params).then(res => {
          if (res.retcode === 1) {
            this.padCodeList = res.data
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
            this.winHeight = windiwHight - 320
          } else {
            net.message(this, res.retmsg, "warning")
          }
        })
      },
      // 生成Pad授权码
      setPadCode(){
        const params = {
          orgId: this.orgId,
          orgName: this.orgName,
          token: this.signInfo.token
        }
        net.request('admin/dossier/deviceAuth/addPadOrgAuthCode','post',params).then(res => {
          if (res.retcode === 1) {
            this.getPadCode()
          } else {
            net.message(this, res.retmsg, "warning")
          }
        })
      },

      // 删除
      delPadCode(row){
        console.log(row)
        this.$confirm('此操作将删除该Pad授权, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            authCode: row.authCode,
            token: this.signInfo.token
          }
          net.request('admin/dossier/deviceAuth/removePadOrgAuthCode','post',params).then(res => {
            if (res.retcode === 1) {
              this.getPadCode()
            } else {
              net.message(this, res.retmsg, "warning")
            }
          })
        })

      },
      // 解绑
      unboundPadCode(row){
        console.log(row)
        this.$confirm('此操作将解绑该Pad授权, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            authCode: row.authCode,
            token: this.signInfo.token
          }
          net.request('admin/dossier/deviceAuth/notPadOrgAuthCode','post',params).then(res => {
            if (res.retcode === 1) {
              this.getPadCode()
            } else {
              net.message(this, res.retmsg, "warning")
            }
          })
        })

      },


    },
  };
</script>

<style lang='less' scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
    .content {
        padding-left: 24px;
        margin-top: 24px;
    }
    .title {
        width: 100%;
        height: 50px;
        line-height: 50px;
        background: #eaeefb;
        color: red;
        font-size: 20px;
        font-weight: 700;
    }
    .searchContent {
        background: #fff;
        padding: 12px 12px;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        .btn {
            width: 76px;
            height: 36px;
            box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
            border-radius: 4px;
            font-size: 14px;
            color: #FFFFFF;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 500;
        }
        .desktop {
            background: #2B54FC;
        }
        .report {
            background: #29D3BF;
        }
        .el-input--suffix {
            width: 200px;
            margin-right: 20px;
        }
    }
    .list_box {
        border-radius: 8px;
        background: #fff;
        margin-top: 24px;
        padding: 12px 24px;
    }
    .list_content {
        /*margin-top: 20px;*/
    }
    .pagination {
        position: relative;
        margin-top: 0;
        background: #fff;
        padding-top: 24px;
        padding-bottom: 10px;
        .el-pagination {
            position: absolute;
            right: 24px;
            .el-pager li:not(.disabled) {
                .active {
                    background: #009688 !important;
                }
            }
        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #009688;
    }
    .select_box {
        text-align: left;
        margin-bottom: 10px;
        .select_title {
            display: inline-block;
            width: 100px;
            text-align: right;
            margin-right: 20px;
        }
    }
    .img_box {
        display: flex;
        .del_box {
            line-height: 150px;
            margin-left: 50px;
        }
    }
    .copy_btn {
      width: 56px;
      height: 28px;
      background: rgba(148, 170, 204, 0.08);
      border: 1px solid #E3E7ED;
      border-radius: 14px;
      text-align: center;
      font-size: 12px;
      color: #364556;
    }
</style>
